/** 任务数量趋势 */
export const weekOrderView = '/task/taskOrder/weekOrderView'

/** 平台工作台采购单审核 */
export const queryCompanyTitleCount = '/yuntian/storeCount/queryCompanyTitleCount'

/** 日常店铺数据 商家&平台通用 */
export const queryDailyCount = '/yuntian/storeCount/queryDailyCount'

/** 近30天成交额---平台&商家视角 */
export const querySalerTendForPlatform = '/yuntian/storeCount/querySalerTendForPlatform'


/** 查询平台订单量---平台&商户视角 */
export const PlatformOrderView = '/yuntian/storeCount/PlatformOrderView'

/** 商家 订单量排行.成交额排行 */
export const queryCompanyRankCount = '/yuntian/storeCount/queryCompanyRankCount'


/*商家列表*/
export const companyList = '/yuntian/company/queryCompanyInfoList'

/*新增商家*/
export const addCompany = '/yuntian/company/addCompany'

/*编辑商家*/
export const editCompany = '/yuntian/company/modifyCompany'

/*编辑商家状态*/
export const editCompanyStatus = '/yuntian/company/modifyCompanyStatus'

/*冻结商家账户*/
export const freezeCompanyAccount = '/yuntian/company/freezeCompanyAccount'

/*重置商家密码*/
export const resetCompanyPassword = '/yuntian/company/resetCompanyPassword'

/*商家编码迁移*/
export const migrateCompanyCode = '/yuntian/company/migrateCompanyCode'

/** 查询权限列表  **/
export const getRoleList = '/role/list'

/** 增加权限列表  **/
export const addRoleData = '/role/create'

/** 编辑权限列表  **/
export const editRoleData = '/role/update'

/** 删除权限列表  **/
export const deleteRoleData = '/role/delete'

/** 根据角色id查询所有菜单  **/
export const getRoleMenuList = '/role/listMenu'

/** 给角色分配菜单  **/
export const allocMenu = '/role/allocMenu'

/** 查询所有菜单  **/
export const getMenuTreeList = '/menu/treeList'

/** 员工列表 **/
export const getDataList = '/admin/list'

/** 员工列表  新增 **/
export const addData = '/admin/register'

/** 员工列表  编辑**/
export const editData = '/admin/update'

/** 员工列表  删除**/
export const deleteData = '/admin/delete'

/** 修改人员站点权限**/
export const saveAdminCountry = '/yuntian/adminCountryRelation/saveAdminCountry'

/*公告管理列表*/
export const queryNoticeInfo = '/yuntian/notice/queryNoticeInfo'

/*公告管理-新增*/
export const createNotice = '/yuntian/notice/createNotice'

/*公告管理-修改*/
export const modifyNotice = '/yuntian/notice/modifyNotice'

/*公告管理-删除*/
export const delNotice = '/yuntian/notice/delNotice'

/*查询列表-仓库SKU*/
export const queryMainSkuList = '/yuntian/goods/queryMainSkuList'

/*查询列表-站点*/
export const queryWarehouseList = '/yuntian/warehouse/queryWarehouseList'

/*仓库sku导入*/
export const batchImportGoods = '/yuntian/goods/batchImportGoods'

/*查询列表 平台sku*/
export const queryGoodsList = '/yuntian/goods/queryGoodsList'

/*新增仓库*/
export const addWarehouse = '/yuntian/warehouse/createWarehouse'

/*编辑仓库*/
export const editWarehouse = '/yuntian/warehouse/modifyWarehouse'

/*修改仓库状态*/
export const editWarehouseStatus = '/yuntian/warehouse/operateWarehouse'

/*查询库存列表*/
export const queryWarehouseGoodsList = '/yuntian/warehouseGoods/queryWarehouseGoodsList'

/*根据站点查询仓库列表*/
export const queryWarehouseByCountryCode = '/yuntian/warehouse/queryWarehouseByCountryCode'

/*查询商家库位规则列表*/
export const queryAccountLocationRules = '/account/accountLocationRules/getAccountLocationRules'

/*新增商家库位规则列表*/
export const addAccountLocationRules = '/account/accountLocationRules/saveAccountLocationRules'

/*编辑商家库位规则列表*/
export const editAccountLocationRules = '/account/accountLocationRules/updateAccountLocationRules'

/*删除商家库位规则列表*/
export const deleteAccountLocationRules = '/account/accountLocationRules/deleteAccountLocationRules'

/*查询账单规则配置*/
export const queryFeeRules = '/account/accountFeeRules/getRules'

/*保存账单规则配置*/
export const saveFeeRules = '/account/accountFeeRules/saveRules'

/*查询商家账单列表*/
export const queryAccountBillList = '/account/accountBill/list'

/*下载商家账单列表*/
export const exportAccountBillList = '/account/accountBill/export'

/*审核*/
export const examineGoods = '/yuntian/goods/examineGoods'

/*查询列表  采购收货*/
export const queryPurchaseOrderList = '/yuntian/purchaseOrder/queryPurchaseOrderList'

/*采购收货  完成收货*/
export const finishReveive = '/yuntian/purchaseOrder/finishReveive'

/*采购收货 导出采购单列表*/
export const outPurchaseOrderList = '/yuntian/purchaseOrder/outPurchaseOrderList'

/*采购发货  查看采购单详情*/
export const queryPurchaseOrderDetail = '/yuntian/purchaseOrder/queryPurchaseOrderDetail'

/*采购发货 确认收货*/
export const purchaseOrderReveiveRecord = '/yuntian/purchaseOrder/purchaseOrderReveiveRecord'

/*推送采购单*/
export const pushSaleOrders = '/yuntian/purchaseOrder/pushPurchaseOrders'

/*审核采购单*/
export const examinePurchaseOrder = '/yuntian/purchaseOrder/examinePurchaseOrder'

/*编辑采购单 更改状态*/
export const dealPurchaseOrder = '/yuntian/purchaseOrder/dealPurchaseOrder'

/*创建采购单*/
export const createPurchaseOrder = '/yuntian/purchaseOrder/createPurchaseOrder'

/*编辑采购单*/
export const modifyPurchaseOrder = '/yuntian/purchaseOrder/modifyPurchaseOrder'

/*商家推送采购单*/
export const pushSaleOrderscgd = '/yuntian/purchaseOrder/pushSaleOrders'

/*销售订单--查询订单顶部的数量*/
export const queryStatusCount = '/yuntian/saleOrder/queryStatusCount'

/*销售订单--查询列表*/
export const querySaleOrder = '/yuntian/saleOrder/querySaleOrder'

/*销售订单--物流详情（点击运单号）*/
export const queryLogisticsDetail = '/yuntian/saleOrder/logisticsDetail'

/*销售订单--展开行实时可销库存（WMS）*/
export const queryItemStock = '/yuntian/saleOrder/queryItemStock'

/*销售订单--发货后行内轮询推送状态*/
export const queryShipStatus = '/yuntian/saleOrder/queryShipStatus'

/*销售订单--订单导出*/
export const outSaleOrder = '/yuntian/saleOrder/outSaleOrder'

/*销售订单--拦截发货*/
export const cancelWmsOrder = '/yuntian/saleOrder/cancelWmsOrder'

/*退货单--查询订单顶部的数量*/
export const queryReturnOrderStatusCount = '/yuntian/returnOrder/queryReturnOrderStatusCount'

/*退货单--查询列表*/
export const queryReturnOrderList = '/yuntian/returnOrder/queryReturnOrderList'

/*私发单管理--查询订单顶部的数量*/
export const queryOrderStatusCount = '/yuntian/privateOrder/queryOrderStatusCount'

/*私发单管理--查询列表*/
export const queryOrderInfoList = '/yuntian/privateOrder/queryOrderInfoList'

/*私发单管理--推送*/
export const pushPrivateOrder = '/yuntian/privateOrder/pushPrivateOrder'

/*私发单管理--审核*/
export const orderExamine = '/yuntian/privateOrder/orderExamine'

/*私发单管理--补充运单号*/
export const addTrackingNumber = '/yuntian/privateOrder/addTrackingNumber'

/*编辑私发单--创建采购单*/
export const createOrder = '/yuntian/privateOrder/createOrder'

/*编辑私发单--查看采购单详情*/
export const backViewPrivateOrder = '/yuntian/privateOrder/backViewPrivateOrder'

/*编辑私发单--编辑采购单*/
export const modifyPrivateOrder = '/yuntian/privateOrder/modifyPrivateOrder'

/*编辑私发单--根据仓库id和商品ids 查询库存*/
export const queryStockByWarehouseCode = '/yuntian/warehouseGoods/queryStockByWarehouseCode'


  /** 新增仓库sku/组合Sku */
export const addSkuData = '/yuntian/goods/creatSku'


/** 查询列表（同 queryAccountBillList） */
export const queryAccountList = '/account/accountBill/list'

/** 导出账单（同 exportAccountBillList） */
export const exportAccountBill = '/account/accountBill/export'

/** 立即生成账单 */
export const createBill = '/account/accountBill/createBill'

/** 查询订单顶部的数量 */
export const queryAccountStatusCount = '/account/accountBill/listCount'

/** 对账详情  /account/accountBill/info/${id}*/
export const fetchBillDetail = '/account/accountBill/info'

/** 账单流水  */
export const getAccountLogList = '/account/accountLog/list'

/** 账单流水详情  /account/accountLog/info?relationInfoId=*/
export const getAccountLogInfo = '/account/accountLog/info'

/** 查询其他费用详情  /account/accountOtherFee/accountOtherFeeDetail/${id}*/
export const accountOtherFeeDetail = '/account/accountOtherFee/accountOtherFeeDetail'


/** 导出账单流水  /account/accountLog/export?billId=${billId}*/
export const exportAccountLog = '/account/accountLog/export'

/** 运营提交给财务审核  /account/accountBill/serviceCommit/${billId}*/
export const serviceCommit = '/account/accountBill/serviceCommit'

/** 客户驳回  /account/accountBill/backBill/${billId}*/
export const backBill = '/account/accountBill/backBill'

/** 创建退仓费  */
export const createRewarehouseFee = '/account/accountOtherFee/createRewarehouseFee'

/** 财务审核运营  */
export const examineService = '/account/accountBill/examineService'

/** 财务审核商户  */
export const examineCompany = '/account/accountBill/examineCompany'

/** 编辑费用  */
export const modifyAccountLog = '/account/accountLog/modifyAccountLog'

/** 商户对账 添加 其他&补贴费用  */
export const addStoreOtherFee = '/account/accountOtherFee/addStoreOtherFee'

/** 发货扣费规则(费率卡) - 分页查询 */
export const shippingChargeRuleList = '/account/shippingChargeRule/list'

/** 发货扣费规则(费率卡) - 新增 */
export const shippingChargeRuleSave = '/account/shippingChargeRule/save'

/** 发货扣费规则(费率卡) - 编辑 */
export const shippingChargeRuleUpdate = '/account/shippingChargeRule/update/'

/** 发货扣费规则(费率卡) - 删除 */
export const shippingChargeRuleDelete = '/account/shippingChargeRule/delete/'

/** 发货扣费规则(费率卡) - 费用试算 */
export const shippingChargeRulePreview = '/account/shippingChargeRule/preview'

/** 商家扣费设置 - 分页查询 */
export const merchantChargeSettingList = '/account/merchantChargeSetting/list'

/** 商家扣费设置 - 查询指定商家 */
export const merchantChargeSettingGetByCompany = '/account/merchantChargeSetting/getByCompany'

/** 商家扣费设置 - 保存/更新 */
export const merchantChargeSettingSaveOrUpdate = '/account/merchantChargeSetting/saveOrUpdate'

/** 商家扣费设置 - 删除 */
export const merchantChargeSettingDelete = '/account/merchantChargeSetting/delete/'

/** 禁发站点 - 分页查询 */
export const shippingBanList = '/account/shippingBan/list'

/** 禁发站点 - 新增 */
export const shippingBanSave = '/account/shippingBan/save'

/** 禁发站点 - 删除 */
export const shippingBanDelete = '/account/shippingBan/delete/'

/** 充值管理列表  **/ 
export const accountList = '/admin/accountOrder/accountList'

/** 查询是否有没有处理的充值记录  **/ 
export const accountSelect = '/admin/accountOrder/accountSelect'

/** 充值审核  **/ 
export const dealAccount = '/admin/accountOrder/dealAccount'

/** 给商家充值  **/ 
export const saveCompanyAccount = '/admin/accountOrder/saveCompanyAccount'

/** 查询公司账户  **/ 
export const queryCompanyAccountInfo = '/admin/companyAccount/info'

/** 收支明细列表  **/ 
export const accountLogList = '/admin/accountSendLog/accountLogList'

/** 收支明细导出  **/ 
export const accountLogListExport = '/admin/accountSendLog/accountLogListExport'

/** 收支明细新增  **/ 
export const accountLogAdd = '/admin/accountSendLog/accountLogAdd'

/** 修改密码 **/
export const updatePassword = '/admin/updatePassword'

/** 操作日志列表 **/
export const queryOperationLogList = '/yuntian/operationLog/list'

/** 告警列表 **/
export const queryAlertList = '/yuntian/alert/list'

/** 未处理告警数量 **/
export const queryAlertUnreadCount = '/yuntian/alert/unreadCount'

/** 处理告警 **/
export const handleAlert = '/yuntian/alert/handle/'

/** 忽略告警 **/
export const ignoreAlert = '/yuntian/alert/ignore/'

/** 菜单管理 - 添加菜单 **/
export const createMenu = '/menu/create'

/** 菜单管理 - 修改菜单 **/
export const updateMenu = '/menu/update/'

/** 菜单管理 - 获取菜单详情 **/
export const getMenuDetail = '/menu/'

/** 菜单管理 - 删除菜单 **/
export const deleteMenu = '/menu/delete/'

/** 菜单管理 - 分页查询菜单 **/
export const listMenu = '/menu/list/'

/** 菜单管理 - 树形结构菜单列表 **/
export const menuTreeList = '/menu/treeList'

/** 菜单管理 - 修改菜单显示状态 **/
export const updateMenuHidden = '/menu/updateHidden/'

/** 系统日志 - 可查看的日志文件列表 **/
export const sysLogFiles = '/sysLog/files'

/** 系统日志 - 尾部读取(支持关键字过滤) **/
export const sysLogTail = '/sysLog/tail'

/** 历史漏扣发货费修复（仅超级管理员） **/
export const repairMissedShippingCharges = '/admin/accountSendLog/repair/missedShippingCharges'

/** 冻结流水列表 **/
export const freezeLogList = '/account/freezeLog/list'

/** 冻结汇总（总冻结金额） **/
export const freezeLogSummary = '/account/freezeLog/summary'




// WEBPACK FOOTER //
// ./src/http/moudules/pf.js